import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { authService } from '../services/auth.service';

const OwnerRoute: React.FC = () => {
  if (!authService.isAuthenticated()) {
    return <Navigate to="/signin" replace />;
  }
  if (!authService.isOwner()) {
    // Tenant or unknown role: redirect appropriately
    const role = authService.getUserRole();
    if (role === 'TENANT') {
      return <Navigate to="/tenant/dashboard" replace />;
    }
    // No role in storage (legacy session) → force re-login
    authService.logout();
    return <Navigate to="/signin" replace />;
  }
  return <Outlet />;
};

export default OwnerRoute;
